import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./components/Login";
import DashboardLayout from "./components/DashboardLayout";
import Home from "./components/Home";
import PostList from "./components/PostList";
import PostForm from "./components/PostForm";
import PostDetail from "./components/PostDetail";
import NotFound from "./components/NotFound";
import BackToTop from "./BackToTop/BackToTop";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="category/:categoryKey" element={<PostList />} />
            <Route path="category/:categoryKey/create" element={<PostForm mode="create" />} />
            <Route path="category/:categoryKey/edit/:id" element={<PostForm mode="edit" />} />
            <Route path="category/:categoryKey/view/:id" element={<PostDetail />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
        <BackToTop />
      </BrowserRouter>
    </AuthProvider>
  );
}
